import { Button, Modal, Typography } from "@/components/atoms";

interface CompleteAllRequiredFieldsModalProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onClose: () => void;
}

export const CompleteAllRequiredFieldsModal = ({ open, onClose, ...props }: CompleteAllRequiredFieldsModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="max-w-[514px] !p-6">
      <div className="relative" {...props}>
        <Typography variant="title">Complete All Required Fields</Typography>
        <Typography variant="paragraph" className="mt-3 text-neutral-dark-gray">
          All required fields must be filled out to verify the vehicle. Please ensure the following are complete:
        </Typography>
        <ul className="mt-2 list-inside list-disc text-neutral-dark-gray">
          <li><Typography variant="paragraph" className="inline text-neutral-dark-gray">Vehicle Type must be selected</Typography></li>
          <li><Typography variant="paragraph" className="inline text-neutral-dark-gray">Insurance document must be uploaded</Typography></li>
        </ul>
        <div className="mt-6 flex justify-end">
          <Button variant="primary" onClick={onClose} size="md">
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
